import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, AlertTitle, Paper } from "@mui/material";

const DisplayError = ({ code }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Success/Error Messages */}

      {code === 2 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>
              {code === 2 ? t("signup.title4") : t("signup.title5")}
            </AlertTitle>
            {t("signup.error1")}
          </Alert>
        </Paper>
      )}

      {code === 3 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>{t("signup.title5")}</AlertTitle>
            {t("signup.error1")}
          </Alert>
        </Paper>
      )}

      {code === 4 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>{t("signup.title4")}</AlertTitle>
            {t("signup.error2")}
          </Alert>
        </Paper>
      )}

      {code === 5 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>{t("signup.title4")}</AlertTitle>
            {t("signup.error3")}
          </Alert>
        </Paper>
      )}

      {code === 6 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>{t("signup.title4")}</AlertTitle>
            {t("signup.error4")}
          </Alert>
        </Paper>
      )}

      {code === 7 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>{t("signup.title4")}</AlertTitle>
            {t("signup.error5")}
          </Alert>
        </Paper>
      )}

      {code === 8 && (
        <Paper elevation={3} className="error-message" sx={{ p: 3, mb: 3 }}>
          <Alert severity="error">
            <AlertTitle>{t("signup.title4")}</AlertTitle>
            {t("signup.error6")}
          </Alert>
        </Paper>
      )}
    </>
  );
};

export default DisplayError;
